import { integrationBlingService } from '../../services/integration-service'
import * as types from './integration-constants'

export const integrationBling = data => dispatch => {
  dispatch({
    type: types.INTEGRATION_BLING_REQUEST,
    payload: integrationBlingService(data)
  })
}
